import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { commonFormStyles, commonLHCOmponentStyle } from '@ahoy/ui/common/styles/common-styles';
import { QuestionsService } from '@APP/services/questions-service';
import { UserService } from '@APP/services/user-service';
import { customElement, property, state } from 'lit/decorators';
import { DeviceAwareComponent } from './device-aware-component';
import { html, css, PropertyValues } from 'lit';
import { Question } from '@APP/model/question';
import { t } from '@APP/utils/locale';
import './checkbox-input';
import { classMap } from 'lit/directives/class-map';
import { InsuranceService } from '@APP/services/insurance-service';
import { unsafeHTML } from 'lit/directives/unsafe-html';
// import { eventBus } from "@APP/utils/event-bus";
// import { Events } from "@APP/events/app-events";


type OwnDeps = {
  questionsService: QuestionsService;
  userService: UserService;
  insuranceService: InsuranceService;
};

@requires(QuestionsService.serviceName, UserService.serviceName, InsuranceService.serviceName)
@customElement('lh-accept-terms-manual-data-attestation')
export class LHAcceptPaymentTermsManualData extends DepInjMixin<OwnDeps>(DeviceAwareComponent) {

  static get baseStyles() {
    return [
      commonLHCOmponentStyle(css),
      commonFormStyles(css),
      css`
        :host([hidden]) {
          display: none;
      }
      :host {
        display: grid;
        grid-gap: 2rem;
      }
      .text_massege{
        font-size: 2.5rem;
        color: var(--c-text);
      }
      #error {
        font-size: 2rem;
        display: block;
        margin: -1rem 0 1rem;
        color: var(--c-err);
      }

      a {
        font-size: 2rem;
        color: var(--c-link);
        text-decoration: underline;
        cursor: pointer;
        width: fit-content;
        margin: 0 4rem;
      }

      .text-terms {
        font-size: 1.5rem;
        color: rgba(18, 18, 19, 0.6);
        display: block;
        margin-left: 4rem;
      }

      :host checkbox-input {
        display: block;
        height: 0rem;
      }

      .text-terms-display-only {
        margin: 0
      }
    `,
    ];
  };

  static get mobileStyles() {
    return [
      css`
        .text-terms { margin: 0 1rem 3rem 5.5rem; }
        .text-terms-display-only{margin:0}
      `,
    ];
  }

  @property({ type: String, attribute: 'question-id' })
    questionId = '';

  @state()
    question: Question | undefined;

  @state()
    showMore: boolean = false;

  @state()
    showErrors: boolean = false;

  private accept = false;

  constructor() {
    super();
  }

  // protected async firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): Promise<void> {
  //   if (_changedProperties.has('questionId')) {
  //     /** Check if ACH question */
  //     const achQuestion = ['accept_ach_payment_terms_summary'].includes(this.questionId);

  //     /** Get routing and account number */
  //     if (achQuestion) {
  //       const { Bank_Account_Number_Routing, Bank_Account_Number } = this.deps.questionsService.getQuestionsValues(['Bank_Account_Number_Routing', 'Bank_Account_Number']);
  //       const data: getBankNameData = {
  //         routingNumber: Bank_Account_Number_Routing || '',
  //         accountNumber: Bank_Account_Number || ''
  //       };

  //       /** Get bank name */
  //       const bankName = await this.deps.insuranceService.getBankName(data);
  //       eventBus(t('ACH')).emit(Events.Type.BankAccountName, bankName.data);
  //     }
  //   }
  // }

  updated(p: PropertyValues<this>) {
    if (p.has('questionId')) {
      this.question = this.deps.questionsService.model.getQuestionById(this.questionId) as Question | undefined;
      this.accept = this.question?.value === '$_BOOL_true';
    }
  }

  public get isValid() {
    return !!this.accept;
  }

  handleShowMore() {
    this.showMore = true;
  }

  private updateQuestionValue() {
    if (this.question) {
      this.question.value = this.accept ? '$_BOOL_true' : '$_BOOL_false';
    }
  }

  handleChange(e: CustomEvent<boolean>) {
    const value = e.detail;
    this.accept = value;
    this.updateQuestionValue();
    this.showErrors = false;
  }

  public runValidations() {
    if (!this.accept) {
      this.showErrors = true;
    }
  }

  public getErrors(): string {
    if (this.showErrors)
      return t('ValidErrAccpetTermsManualData');
    else
      return '';
  }

  renderContent() {
    /** ACH approval text. No need for checkbox */
    const textArr = this.question?.metadata ? this.question.metadata.text : '';
    let textWithLineBreaks;
    if (textArr) {
      textWithLineBreaks = textArr.map((text: string) => t(text));
    }

    const spanClasses = {
      'text-terms': true,
      'text-terms-display-only': !!textArr,
    };

    return html`
      <span class="entry">
        ${this.showErrors ? html`<span id='error'>${t('ValidErrAccpetTermsManualData')}</span>` : void 0}
        ${textArr ? '' : html`<checkbox-input .customizations=${true} .checkedInput=${this.accept} @change=${this.handleChange}></checkbox-input>`}
        ${textArr ?
    html`<span class=${classMap(spanClasses)}>${textWithLineBreaks}</span>`
    : html`<span class=${classMap(spanClasses)}>${unsafeHTML(t('T_Approved_Manual_Data_Attestation'))}</span>`}
      </span>
  `;
  }

}